import script from "./AdminSystemSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminSystemSettings.vue?vue&type=script&setup=true&lang=js"

import "./AdminSystemSettings.vue?vue&type=style&index=0&id=735f50be&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-735f50be"]])

export default __exports__